<template>
  <v-modal
    v-if="showModal"
    id="build-modal"
    :adaptive="true"
    :click-to-close="false"
    :scrollable="false"
    height="100%"
    name="your-bag-gallery"
    width="100%"
    @before-open="toggleBodyScrollClass(true)"
    @before-close="toggleBodyScrollClass(false)"
  >
    <button class="close right" @click="hideModal">x</button>
    <div class="slider-bikes">
      <div v-if="groups.length > 0" class="title">
        {{ build['model_title'] }} <strong>{{ build['build_title'].title }}</strong>
      </div>
      <div v-if="groups.length > 0 && titles.length > 0" class="nav-mobile">
        <ul class="viewport">
          <li v-for="item in sortedTitles">
            <button :class="mobileNavClass(item)" @click.prevent="show(item, null)">
              {{ item.title }}
            </button>
          </li>
        </ul>
      </div>
      <div class='center-wrapper'>
        <div class="slider-gallery">
          <flickity
            id="main2"
            ref="main2"
            v-images-loaded="imgsLoaded"
            :class="flickityClass"
            :options="mainGalleryOption"
            class="slider-gallery-main"
          >
            <div
              v-for="(item, idx) in items"
              :key="idx"
              class="carousel-cell">
              <img :alt="item.title" :src="getImageSource(item)"/>
            </div>
          </flickity>

          <flickity
            id="sub2"
            ref="sub2"
            :class="flickitySubClass"
            :options="navBagOptions2"
            class="slider-gallery-nav"
          >
            <div
              v-for="(item, idx) in images"
              :key="idx"
              class="carousel-cell"
              @click="selectSlide2(idx)"
            >
              <div class="wrapper-img">
                <img :alt="item.title" :src="getImageSource(item)"/>
              </div>
            </div>
          </flickity>
        </div>
        <div v-if="groups.length > 0" class="downPanel">
          <div class="selectColor">
            <div v-for="group in groups" :key="group.id" class="group">
              <div class="checkboxes">
                <div v-for="color in group.colors" :key="color.id">
                  <div class="checkbox">
                    <input
                      :id="`color-${color.id}-group-${group.id}-zoom`"
                      :checked="isColorChecked(color)"
                      :title="color.title"
                      name="color"
                      type="radio"
                    >
                    <label
                      for="`color-${color.id}-group-${group.id}-zoom`"
                      @click="show(build['build_title'], color)"
                    >
                      <img :alt="color.title" :src="color.image">
                    </label>
                  </div>
                </div>
              </div>
              <p class="fs-12 bold">{{ group.title }}
                <span
                  v-if="group.price > 0"
                  class="color-gray"
                >
                  {{ $crConverter(group.price / 100, 'EUR', '%s +%v') }}
                </span>
              </p>
            </div>
          </div>
          <div class="total">
            <p v-if="!outOfStock" class="fs-12">Retail price:</p>
            <p v-if="!outOfStock" class="fs-24">{{ $crConverter(buildPrice / 100, 'EUR', '%s %v') }}</p>
            <a
              v-if="!outOfStock"
              class="btn btn-green"
              :href="buildUrl"
            >
              Order
            </a>

            <p v-if="outOfStock" class="fs-17 mt-0 mb-3">Out of stock</p>
            <a
              v-if="outOfStock" :href="`/en/contact?subject=${build['model_title']} out of stock`"
              class="btn btn-gray"
              target="_blank"
            >
              Contact us
            </a>
          </div>
        </div>
        <button
          v-if="groups.length > 0 && showArrow(true)"
          class="arrow prev"
          @click.prevent="show(getSpecific(true))"
        >
          <span class="arrow__name">{{ getSpecificTitle(true) }}</span>
          <span v-if="false" class="arrow__text">Prev build</span>
          <svg fill="none" height="12" viewBox="0 0 8 12" width="8" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.999999 11.4531L6 6.45313L1 1.45312" stroke="black" stroke-width="1.5"></path>
          </svg>
        </button>
        <button
          v-if="groups.length > 0 && showArrow(false)"
          class="arrow next"
          @click.prevent="show(getSpecific(false))"
        >
          <span class="arrow__name">{{ getSpecificTitle(false) }}</span>
          <span v-if="false" class="arrow__text">Next build</span>
          <svg fill="none" height="12" viewBox="0 0 8 12" width="8" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.999999 11.4531L6 6.45313L1 1.45312" stroke="black" stroke-width="1.5"></path>
          </svg>
        </button>
      </div>
    </div>
    <div
      v-if="zoom"
      :class="zoomClass"
      class="zoom-box"
      @mousemove="handleMouseMove"
    >
      <button class="close right" @click="closeZoom">x</button>
      <button class="arr prev" @click="prev">prev</button>
      <img
        ref="zoomable"
        :src="currentSlideImage"
        @click="zoomTrigger"
      />
      <button class="arr next" @click="next">next</button>
    </div>
    <span
      v-shortkey="{up: ['arrowup'], down: ['arrowdown'], left: ['arrowleft'], right: ['arrowright']}"
      style="display:none"
      @shortkey="changeSlide">
    </span>
  </v-modal>
</template>

<script>
import Flickity from 'vue-flickity'
import imagesLoaded from 'vue-images-loaded'
import "flickity-fade";
import {mapGetters} from "vuex";

export default {
  name: "ZoomGallery",
  components: {
    Flickity,
  },
  directives: {
    imagesLoaded,
  },
  computed: {
    ...mapGetters({
      notRedirectFromZoom: 'build/notRedirectFromZoom'
    }),
    buildUrl() {
      let url = '/en/choose';

      console.log("Build zoom gallery", this.build)

      if (this.build) {
        url += '/' + this.build.model_slug;

        if (this.build?.build_title?.slug) {
          url += '/' + this.build.build_title.slug;

          if (this.build?.color?.slug) {
            url += '/' + this.build.color.slug;
          }
        }
      }

      return url
    },
    images() {
      return this.$store.state.build.zoomBuild.media.images
    },
    flickitySubClass() {
      return {
        'hidden-sub': !this.showSlider
      }
    },
    flickityClass() {
      return {
        hidden: !this.showSlider
      }
    },
    sortedTitles() {
      let items = this.titles
      let result = [];
      let sorting = ['Halo', 'Neon', 'Diode', 'Edition one', 'Frame Kit'];

      sorting.forEach(function (key) {
        let found = false;
        items = items.filter((item) => {
          if (!found && item.title === key) {
            result.push(item);
            found = true;
            return false;
          } else
            return true;
        })
      })
      return result
    },
    outOfStock() {
      return this.build.blocked
    },
    buildPrice() {
      if (this.build) {
        return this.build['prices']['price_for_eu']
      }

      return 0
    },
    titles() {
      return this.$store.state.build.zoomTitles
    },
    build() {
      return this.$store.state.build.zoomBuild
    },
    showModal() {
      return !!this.$store.state.build.zoomBuild
    },
    zoomClass() {
      return {
        zoomed: this.zoomed,
      }
    },
    items() {
      return this.$store.state.build.zoomBuild.media.images
    },
    groups() {
      return this.$store.state.build.zoomGroups
    },
    currentSlideImage() {
      if (typeof this.currentSlide === 'string') {
        return this.currentSlide
      }
      return this.currentSlide.path
    }
  },
  data() {
    return {
      disabled: false,
      showSlider: false,
      mainGalleryOption: {
        prevNextButtons: false,
        pageDots: false,
        fade: true,
        imagesLoaded: true,
        on: {
          staticClick: (event, pointer, cellElement, cellIndex) => {
            this.showZoom(cellIndex)
          },
          change: (index) => {
            this.changeSubSlider2(index)
          },
        },
      },
      navBagOptions2: {
        contain: true,
        imagesLoaded: true,
        pageDots: false,
        prevNextButtons: true,
        cellAlign: 'left',
        on: {
          change: (index) => {
            this.changeMainSlider2(index)
            this.currentSlide = this.items[index]
          },
        },
      },
      zoomed: false,
      zoom: false,
      imageX: 0,
      imageY: 0,
      currentSlide: null,
    }
  },
  methods: {
    order(event) {
      if (this.notRedirectFromZoom) {
        event.preventDefault()
        this.$root.$emit('chooseBuildFromZoom', this.build)
        this.disabled = true
        setTimeout(() => {
          this.closeZoom()
          this.$modal.hide('your-bag-gallery')
          this.disabled = false
        }, 350)
      }
    },
    toggleBodyScrollClass(status) {
      if (status) {
        document.getElementsByTagName('body')[0].classList.add('vh100')
      } else {
        document.getElementsByTagName('body')[0].classList.remove('vh100')
      }
    },
    imgsLoaded() {
      this.showSlider = true
      this.$nextTick(() => {
        let main = this.$refs.main2
        let sub = this.$refs.sub2
        main.reloadCells()
        sub.reloadCells()
        main.resize()
        sub.resize()
        main.rerender()
        sub.rerender()
      })
    },
    show(title, color = null) {
      if (title['created_at'] === undefined) {
        title = this.titles.find(item => {
          console.log("ITEM & TITLE", item, title)
          return item?.id === title?.id
        })
      }
      this.$root.$emit('changeZoomBuild', {title, build: this.build, color})
    },
    getSpecificTitle(prev) {
      let title = this.getSpecific(prev)
      if (title) {
        return title.title
      }
      return null
    },
    getSpecific(prev) {
      let currentTitle = this.build['build_title'].id
      let index = Array.from(this.sortedTitles).findIndex(item => {
        return item.id === currentTitle
      })

      if (index !== -1) {
        let newIndex = prev ? (index - 1) : index + 1
        return this.sortedTitles[newIndex]
      } else {
        return null
      }
    },
    showArrow(prev = true) {
      return !!this.getSpecific(prev)
    },
    mobileNavClass(title) {
      return {
        active: this.build['build_title'].id === title.id
      }
    },
    isColorChecked(color) {
      return this.build.color.id === color.id
    },
    changeSlide(event) {
      switch (event.srcKey) {
        case 'down':
          if (this.zoom) {
            this.next()
          } else {
            this.$refs.sub2.previous(true)
            this.$refs.main2.previous(true)
          }
          break
        case 'up':
          if (this.zoom) {
            this.prev()
          } else {
            this.$refs.sub2.next(true)
            this.$refs.main2.next(true)
          }
          break
        case 'right':
          if (this.zoom) {
            this.next()
          } else {
            this.$refs.sub2.previous(true)
            this.$refs.main2.previous(true)
          }
          break
        case 'left':
          if (this.zoom) {
            this.prev()
          } else {
            this.$refs.sub2.next(true)
            this.$refs.main2.next(true)
          }
          break
      }
    },
    getImageSource(item) {
      if (item.hasOwnProperty('path')) {
        return item.path
      }

      return item
    },
    hideModal() {
      this.$modal.hide('your-bag-gallery')
    },
    changeMainSlider2(index) {
      this.$refs.main2.select(index)
    },
    changeSubSlider2(index) {
      this.$refs.sub2.select(index)
    },
    selectSlide2(index) {
      this.$refs.sub2.select(index)
      this.$refs.main2.select(index)
    },

    zoomTrigger(event) {
      this.zoomed = !this.zoomed
      if (this.zoomed) {
        let x = event.clientX
        let y = event.clientY
        this.imageX = x - this.$refs.zoomable.offsetLeft
        this.imageY = y - this.$refs.zoomable.offsetTop
        this.$refs.zoomable.style.left = x - this.imageX + 'px'
        this.$refs.zoomable.style.top = y - this.imageY + 'px'
      } else {
        this.imageX = 0
        this.imageY = 0
        this.$refs.zoomable.style.left = 0
        this.$refs.zoomable.style.top = 0
      }
    },
    handleMouseMove(event) {
      if (this.zoomed) {
        let x = event.clientX
        let y = event.clientY
        this.$refs.zoomable.style.left = x - this.imageX + 'px'
        this.$refs.zoomable.style.top = y - this.imageY + 'px'
      }
    },
    closeZoom() {
      this.zoom = false
      this.currentSlide = null
    },
    showZoom(cellIndex) {
      this.zoom = true
      this.currentSlide = this.items[cellIndex]
    },
    prev() {
      this.zoomed = false
      this.animateChange('previous')
    },
    next() {
      this.zoomed = false
      this.animateChange('next')
    },
    animateChange(direction) {
      if (this.$refs.zoomable) {
        this.$refs.zoomable.style.opacity = 0
        setTimeout(() => {
          this.$refs.sub2[direction](true)
          setTimeout(() => {
            this.$refs.zoomable.style.opacity = 1
          }, 400)
        }, 200)
      }
    },
  },
  watch: {
    build(newValue, oldValue) {
      if (!!oldValue && newValue.id !== oldValue.id) {
        this.showSlider = false
      }
    },
  }
}
</script>

<style lang="scss">
.slider-gallery-main,
.slider-gallery-nav {
  transition: opacity 0.4s ease-in-out;
}

.slider-gallery-main {
  .carousel-cell {
    opacity: 0 !important;
    z-index: 0;

    &.is-selected {
      opacity: 1 !important;
      z-index: 100;
    }
  }
}

.hidden {
  opacity: 0;
  max-height: 456px;
  overflow-y: hidden;
}

.hidden-sub {
  opacity: 0;
  max-height: 456px;
  overflow-y: hidden;
}
</style>
